/**
 * <usp-slider>
 * Turns the product USP list into a Swiper slider.
 * Swiper is loaded globally in layout/theme.liquid, so no extra vendor script is needed here.
 */
class UspSlider extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.destroy();
  }

  get slides() {
    return this.querySelectorAll('.swiper-slide');
  }

  intSetting(name, fallback) {
    const value = parseInt(this.dataset[name], 10);
    return Number.isNaN(value) ? fallback : value;
  }

  init() {
    if (this.swiper || typeof window.Swiper === 'undefined') return;

    const slideCount = this.slides.length;
    if (slideCount === 0) return;

    const slidesMobile = this.intSetting('slidesMobile', 1);
    const slidesDesktop = this.intSetting('slidesDesktop', 2);
    const autoplayDelay = this.intSetting('autoplay', 0);
    const pagination = this.querySelector('.swiper-pagination');

    this.swiper = new window.Swiper(this, {
      slidesPerView: slidesMobile,
      spaceBetween: 16,
      watchOverflow: true,
      // Fewer slides than slidesPerView would otherwise leave the track hugging the left edge.
      centerInsufficientSlides: true,
      // Looping duplicates slides, which only makes sense when they actually overflow.
      loop: this.dataset.loop === 'true' && slideCount > slidesDesktop,
      autoplay:
        autoplayDelay > 0
          ? { delay: autoplayDelay, disableOnInteraction: true, pauseOnMouseEnter: true }
          : false,
      pagination: pagination ? { el: pagination, clickable: true } : false,
      breakpoints: {
        768: {
          slidesPerView: slidesDesktop,
        },
      },
      a11y: {
        enabled: true,
        containerMessage: this.getAttribute('aria-label') || 'Product USPs',
      },
    });
  }

  destroy() {
    if (!this.swiper) return;
    this.swiper.destroy(true, true);
    this.swiper = null;
  }
}

if (!customElements.get('usp-slider')) {
  customElements.define('usp-slider', UspSlider);
}
